const routes = [

  { // 教学空间
    path: "/n-homepage",
    name: "n-homepage",
    component: () => import('../views/szrt_revision/new_course_module/homepage.vue'),
    children: [
      {
        path: "/TheoryCourse",
        // name: "TheoryCourse",
        component: () => import('../views/szrt_revision/new_course_module/index.vue'),
        children: [
          {// 教学班
            path: "/TheoryCourse/TeachingClass",
            component: () => import('../views/szrt_revision/new_course_module/teachingClass.vue')
          },
          {// 课程库
            path: "/TheoryCourse/CourseLibrary",
            component: () => import('../views/szrt_revision/new_course_module/courseLibrary.vue')
          },
					{// 测评
					  path: "/TheoryCourse/Evaluation",
					  component: () => import('../views/szrt_revision/new_course_module/evaluation.vue')
					},
          {// 编辑课程
            path: "/n-EditCourse",
            component: () => import('../views/szrt_revision/new_course_module/editCourse/index.vue')
          },
          {// 编辑测评
            path: "/n-addTest",
            component: () => import('@/components/views/course/addTestpaper.vue')
          },
          {// 融通校考
            path: "/TheoryCourse/examination",
            component: () => import('../views/szrt_revision/new_course_module/schoolExamination.vue')
          },
          {// 模拟考试
					  path: "/TheoryCourse/MockExamination",
					  component: () => import('../views/szrt_revision/new_course_module/mockExamination/index.vue')
          },
          {// 应用中心
					  path: "/TheoryCourse/appCenter",
					  component: () => import('../views/szrt_revision/new_course_module/appCenter/index.vue')
          },
        ]
      },
    ]
  },
  { // 教学详情
    path: "/teachingDetail",
    name: "teachingDetail",
    component: () => import('../views/szrt_revision/teachingDetail/index.vue'),
    children: [
      {// 学员
        path: "/teachingDetail/studentDetail",
        component: () => import('../views/szrt_revision/teachingDetail/other/student/index.vue')
      },
      {// 统计
        path: "/teachingDetail/statisticsDetail",
        component: () => import('../views/szrt_revision/teachingDetail/other/statistics/index.vue'),
        children: [
          // { // 学生理论课统计
          //   path:"/teachingDetail/statisticsDetail/studentTheory",
          //   component: () => import('../views/szrt_revision/teachingDetail/other/statistics/student/studentTheory.vue'),
          // },
          { // 教师理论课统计
            path:"/teachingDetail/statisticsDetail/teacherTheory",
            component: () => import('../views/szrt_revision/teachingDetail/other/statistics/teacher/teacherTheory.vue'),
          },
          // { // 班级进度详情
          //   path:"/teachingDetail/statisticsDetail/classProgress",
          //   component: () => import('../components/views/studyCenter/switch/statistics/teacher/classProgress.vue'),
          // },
          // { // 学习时长详情
          //   path:"/teachingDetail/statisticsDetail/learningDuration",
          //   component: () => import('../components/views/studyCenter/switch/statistics/teacher/learningDuration.vue'),
          // },
          // { // 班级讨论详情
          //   path:"/teachingDetail/statisticsDetail/classDiscuss",
          //   component: () => import('../components/views/studyCenter/switch/statistics/teacher/classDiscuss.vue'),
          // },
          // { // 班级笔记详情
          //   path:"/teachingDetail/statisticsDetail/publicNotes",
          //   component: () => import('../components/views/studyCenter/switch/statistics/teacher/publicNotes.vue'),
          // },
          // { // 班级公开笔记列表
          //   path:"/teachingDetail/statisticsDetail/publicNoteList",
          //   component: () => import('../components/views/studyCenter/switch/statistics/teacher/publicNoteList.vue'),
          // }
        ]
      },
      { // 学生理论课统计
        path:"/teachingDetail/statisticsDetail/studentTheory",
        component: () => import('../views/dataStatistics/student/classStatistics.vue'),
      },
      {// 设置
        path: "/teachingDetail/settingDetail",
        component: () => import('../views/szrt_revision/teachingDetail/other/setting/index.vue')
      },
      {// 资源
        path: "/teachingDetail/sourceDetail",
        component: () => import('../views/szrt_revision/teachingDetail/list/source/index.vue')
      },
      {// 实训
        path: "/teachingDetail/trainingDetail",
        component: () => import('../views/szrt_revision/teachingDetail/list/training/index.vue')
      },
      {// 课程
        path: "/teachingDetail/courseDetail",
        component: () => import('../views/szrt_revision/teachingDetail/list/course/index.vue')
      },
      {// 测评
        path: "/teachingDetail/evaluationDetail",
        component: () => import('../views/szrt_revision/teachingDetail/list/evaluation/index.vue'),
				children: [
					{ //添加编辑考试
						path: "/teachingDetail/AddExam",
						component: () => import('../views/szrt_revision/teachingDetail/list/evaluation/addExam.vue'),
					}
				]
      },
			{// 模拟考试
			  path: "/teachingDetail/mockevaluationDetail",
			  component: () => import('../views/szrt_revision/teachingDetail/list/mockexamination/index.vue'),
				children: [
					{ //添加编辑考试
						path: "/teachingDetail/mockeAddExam",
						component: () => import('../views/szrt_revision/teachingDetail/list/mockexamination/addExam.vue'),
					}
				]
			},
      {// 讨论
        path: "/teachingDetail/discussDetail",
				redirect: "/teachingDetail/discussDetail/all",
        component: () => import('../views/szrt_revision/teachingDetail/list/discuss/index.vue'),
				children:[
				  { // 全部讨论
				    path:"/teachingDetail/discussDetail/all",
				    component: () => import('../views/szrt_revision/teachingDetail/list/discuss/allDiscuss/allDiscuss.vue')
				  },
				  { // 老师答疑
				    path:"/teachingDetail/discussDetail/teacher",
				    component: () => import('../views/szrt_revision/teachingDetail/list/discuss/teacherDiscuss/teacherDiscuss.vue')
				  },
				  { // 课堂交流
				    path:"/teachingDetail/discussDetail/student",
				    component: () => import('../views/szrt_revision/teachingDetail/list/discuss/studentDiscuss/studentDiscuss.vue')
				  }
				]
      },
      {// 笔记
        path: "/teachingDetail/noteDetail",
        component: () => import('../views/szrt_revision/teachingDetail/list/note/index.vue')
      },
      {// 通知
        path: "/teachingDetail/noticeDetail",
        component: () => import('../views/szrt_revision/teachingDetail/list/notice/index.vue')
      },
      { // 试卷编辑
        path: "/teachingDetail/editPapers",
        component: () => import('../views/szrt_revision/new_course_module/editCourse/testPaper/indexNew.vue')
      },
      {// 自由练习
        path: "/teachingDetail/practiceDetail",
        component: () => import('../views/szrt_revision/teachingDetail/list/practice/practice.vue')
      },
      {// 自由练习老师段
        path: "/teachingDetail/practiceDetailAdmin",
        component: () => import('../views/szrt_revision/teachingDetail/list/practice/nopractive.vue')
      },
      {// 作业教师端
        path: "/teachingDetail/workTeacher",
        redirect: "/teachingDetail/workTeacher/manager",
        component: () => import('../views/szrt_revision/teachingDetail/list/work/workTeacher.vue'),
        children: [
          { // 作业管理
            path: "/teachingDetail/workTeacher/manager",
            component: () => import('../views/szrt_revision/teachingDetail/list/work/components/WorkManage.vue'),
          },
          { // 作业库
            path: "/teachingDetail/workTeacher/template",
            component: () => import('../views/szrt_revision/teachingDetail/list/work/components/WorkTemplate.vue'),
          },
          { // 发布作业
            path: "/teachingDetail/workTeacher/issue",
            component: () => import('../views/szrt_revision/teachingDetail/list/work/components/IssueWork.vue'),
          },
          { // 发布作业 - success
            path: "/teachingDetail/workTeacher/issueSuccess",
            component: () => import('../views/szrt_revision/teachingDetail/list/work/components/IssueSuccess.vue'),
          },
          { // 批阅作业 - list
            path: "/teachingDetail/workTeacher/remarkList",
            component: () => import('../views/szrt_revision/teachingDetail/list/work/components/RemarkList.vue'),
          },
          { // 批阅
            path: "/teachingDetail/workTeacher/remark",
            component: () => import('../views/szrt_revision/teachingDetail/list/work/components/Remark.vue'),
          },
        ]
      },
      {// 作业学生端
        path: "/teachingDetail/workStudent",
        component: () => import('../views/szrt_revision/teachingDetail/list/work/workStudent.vue'),
      },
      {// 板书
        path: "/teachingDetail/blackboardWriting",
        component: () => import('../views/szrt_revision/teachingDetail/list/blackboardWriting/index.vue'),
      },
      {// 排名
        path: "/teachingDetail/ranking",
        component: () => import('../views/szrt_revision/teachingDetail/list/ranking.vue'),
      },
      {// 反馈
        path: "/teachingDetail/feedback",
        component: () => import('../views/szrt_revision/teachingDetail/list/feedback/index.vue')
      },
      // {// 作业学生端
      //   path: "/teachingDetail/blackboardWriting",
      //   component: () => import('../views/szrt_revision/teachingDetail/list/blackboardWriting/index.vue'),
      // },
      {// 作业学生端
        path: "/teachingDetail/ranking",
        component: () => import('../views/szrt_revision/teachingDetail/list/ranking.vue'),
      },
    ]
  },
  {
  //答题
    path: "/studentManage",
    name: "studentManage",
    component: () => import('../views/szrt_revision/teachingDetail/list/work/components/studentManage.vue'),
  },
  { // 教务中心
    path: "/n-educa",
    name: "n-educa",
    component: () => import('../views/szrt_revision/new_educa_module/homepage.vue'),
    children: [
      {
        path: "/n-educa/teacher",
        // name: "教师管理",
        component: () => import('../views/szrt_revision/new_educa_module/educa/teacherManage/teacherAdmin.vue'),
      },
      {
        path: "/n-educa/student",
        // name: "学生管理",
        component: () => import('../views/szrt_revision/new_educa_module/educa/studentManage/studentAdmin.vue'),
      },
      {
        path: "/n-educa/sourcesubject",
        // name: "科目管理",
        component: () => import('../components/views/educationalAdmin/educationalAdminMenu/sourceSubject.vue'),
      },
      {
        path: "/n-educa/curriculum",
        // name: "课程授权",
        component: () => import('../components/views/educationalAdmin/educationalAdminMenu/courseSharing.vue'),
      },
      {
        path: "/n-educa/schoollogo",
        // name: "学校logo",
        component: () => import('../views/szrt_revision/new_educa_module/educa/logoManage/schoolLogo.vue'),
      },
      {
        path: "/n-educa/coursePlan",
        // name: "开课计划",
        component: () => import('../views/szrt_revision/new_educa_module/educa/classPlan/coursePlan.vue'),
      },
      {
        path: "/n-educa/sourcesubject/dtails",
        // name: "科目详情",
        component: () => import('../components/views/educationalAdmin/educationalAdminMenu/sourcesubjectDetails.vue'),
      },
      {
        path: "/n-educa/testApply",
        // name: "考试报名",
        component: () => import('../components/views/educationalAdmin/educationalAdminMenu/testApply.vue'),
      },
      {
        path: "/n-educa/appliedList",
        // name: "已报名单",
        component: () => import('../components/views/educationalAdmin/educationalAdminMenu/appliedList.vue'),
      },
      {
        path: "/n-educa/teacherPlan",
        // name: "教学计划填报",
        component: () => import('../components/views/educationalAdmin/educationalAdminMenu/teacherPlan.vue'),
      },
      {
        path: "/n-educa/classStatistics",
        // name: "班课统计",
        component: () => import('../views/szrt_revision/new_educa_module/educa/classStatistics/index.vue'),
      },
      {
        path: "/n-educa/classStatistics/studentList",
        // name: "学员列表",
        component: () => import('../views/szrt_revision/new_educa_module/educa/classStatistics/studentList.vue'),
      },
      {
        path: "/n-educa/examinationManage",
        // name: "校考管理",
        component: () => import('../views/szrt_revision/new_educa_module/educa/examinationManage.vue'),
      },
      {
        path: "/n-educa/organization",
        // name: "组织管理",
        component: () => import('../views/szrt_revision/new_educa_module/educa/organization/index.vue'),
      },
    ]
  },
  { // 个人中心
    path: "/n-settings",
    name: "n-settings",
    component: () => import('../views/szrt_revision/new_account_settings/homepage.vue'),
    children: [
      {
        path: "/n-settings/personalInformation",
        // name: "个人信息",
        component: () => import('../views/szrt_revision/new_account_settings/accountSettings/personalInformation.vue'),
      },
      {
        path: "/n-settings/changePassword",
        // name: "修改密码",
        component: () => import('../views/szrt_revision/new_account_settings/accountSettings/changePassword.vue'),
      },
      {
        path: "/n-settings/securitySetting",
        // name: "安全设置",
        component: () => import('../views/szrt_revision/new_account_settings/accountSettings/securitySetting.vue'),
      },
    ]
  },
  { // 学习空间
    path: "/n-study",
    name: "n-study",
    component: () => import('../views/szrt_revision/new_study_module/homepage.vue'),
    children: [
      {
        path: "/n-study/courseware",
        // name: "我的课程",
        component: () => import('../views/szrt_revision/new_study_module/courseLsit/index.vue'),
      },
      {
        path: "/n-study/examination",
        // name: "融通校考",
        component: () => import('../views/szrt_revision/new_study_module/schoolExamination/index.vue'),
      },
      {// 应用中心
        path: "/n-study/appCenter",
        component: () => import('../views/szrt_revision/new_course_module/appCenter/index.vue')
      },
      {// 模拟考试
        path: "/n-study/MockExamination",
        component: () => import('../views/szrt_revision/new_study_module/mockExamination/index.vue')
      },
    ]
  },
  { // 学习详情页
    path: "/LearningDetails",
    name: "LearningDetails",
    component: () => import('../views/szrt_revision/Learning_details/index.vue'),
  },
  { // 课程预览
    path: "/coursePreview",
    name: "coursePreview",
    component: () => import('../views/szrt_revision/coursePreview/index.vue'),
  },
  { // 课程预览-临时 为了演示使用
    path: "/coursePreviewTest",
    name: "coursePreviewTest",
    component: () => import('../views/demo/coursePreviewTest.vue'),
  },
  { // 课程预览
    path: "/addRichText",
    name: "addRichText",
    component: () => import('../views/szrt_revision/coursePreview/addRichText.vue'),
  },
  { // 课程编辑页-新
    path: "/courseEditPage",
    name: "courseEditPage",
    component: () => import('../views/szrt_revision/new_course_module/courseEditPage/index.vue'),
  },
  { // 助教/老师批注
    path: "/teacherPostil",
    name: "teacherPostil",
    component: () => import('../views/szrt_revision/teachingDetail/other/statistics/teacher/teacherPostil.vue'),
  },
  {// 上课
    path: "/classRoom",
    component: () => import('../views/szrt_revision/teachingDetail/list/classroom/index.vue')
  },
  {// 老师信息
    path: "/teacherInfo",
    component: () => import('../views/szrt_revision/new_educa_module/educa/components/teacherInfo.vue')
  },
	{ // 办公空间
	  path: "/n-rhomepage",
	  name: "n-rhomepage",
	  component: () => import('../views/szrt_revision/new_real_module/rhomepage.vue'),
	  children: [
	    {
	      path: "/newRealTask",
	      component: () => import('../views/szrt_revision/new_real_module/index.vue'),
	      children: [
	        {// 项目团队(教师端)
	          path: "/newRealTask/ProjectTeam",
	          component: () => import('../views/szrt_revision/new_real_module/projectTeam.vue'),
	        },
          {// 项目团队(学生端)
            path: "/newRealTask/Stu/ProjectTeam",
            component: () => import('../views/szrt_revision/new_real_module/projectStuTeam.vue'),
          },
					{// 辅助工具
					  path: "/newRealTask/assistTools",
					  component: () => import('../views/szrt_revision/new_real_module/assistTools.vue')
					},
					{// 企业微课
					  path: "/newRealTask/microLecture",
					  component: () => import('../views/szrt_revision/new_real_module/microLecture.vue')
					},
	        {// 项目资料
	          path: "/newRealTask/ProjectData",
	          component: () => import('../views/szrt_revision/new_real_module/projectData.vue')
	        },
          {// 项目通知信息
            path: "/newRealTask/projectInfor",
            component: () => import('../views/szrt_revision/new_real_module/projectInfor.vue')
          },
	      ]
	    },
	  ]
	},
  {// 项目资料编辑
    path: "/newRealTask/ProjectEdit",
    component: () => import('../views/szrt_revision/new_real_module/projectEdit.vue')
  },
  {// 项目资料预览
    path: "/newRealTask/previewInformation",
    component: () => import('../views/szrt_revision/new_real_module/previewInformation.vue')
  },
	{// 项目团队详情
	  path: "/newRealTask/projectDetail",
	  component: () => import('../views/szrt_revision/new_real_module/pteam/teamDetail.vue')
	},
	{// 项目团队管理
	  path: "/newRealTask/teamAdmin",
	  component: () => import('../views/szrt_revision/new_real_module/pteam/teamAdmin.vue')
	},
	{// 进入指导
	  path: "/newRealTask/intoSystem",
	  component: () => import('../views/szrt_revision/new_real_module/pteam/intoSystem.vue')
	}
]
export default routes;



// WEBPACK FOOTER //
// ./src/router/new-course.js